import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../../hooks";
import { useDispatch, useSelector } from "../../../../redux/hooks";
import { toggleSectionCollapse } from "../../../../redux/slices/generatorSlice";
import { setEditing } from "../../../../redux/slices/entrySlice";

interface Props {
  title?: string;
  subtitle?: string;
  sectionIndex?: number;
  collapseable?: boolean;
  collapsed?: boolean;
  asTableHeader?: boolean;
}

const SectionTitle = ({
  title,
  subtitle,
  sectionIndex,
  collapseable,
  collapsed,
  asTableHeader = false,
}: Props) => {
  const theme = useTheme() as any;
  const dispatch = useDispatch();
  const location = useLocation();
  const isInLogbookEntry =
    location.pathname.includes("/logbook/") &&
    !location.pathname.includes("/history");
  const type = useSelector(
    state => state.entriesGeneratorSlice.reportDetails?.type,
  );

  const handleToggleCollapse = () => {
    if (collapseable && typeof sectionIndex === "number" && isInLogbookEntry) {
      dispatch(toggleSectionCollapse({ sectionIndex }));
      dispatch(setEditing(true));
    }
  };

  const showCollapseControl = collapseable && isInLogbookEntry;

  if (!title && !subtitle) return null;

  const sharedStyles = {
    border: `1px solid ${theme.colors.thBorder[0]}`,
    borderBottom: "none",
    padding: type === 3 ? "6px" : "12px",
    margin: 0,
    textAlign: "start" as const,
    backgroundColor: theme.colors.thBackgroundColor[0],
    color: theme.colors.thColor[0],
    fontWeight: "bold" as const,
    fontSize: "0.875rem",
    cursor: showCollapseControl ? "pointer" : "default",
  };

  const content = (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        {title && <span>{title}</span>}
        {subtitle && (
          <span style={{ fontSize: "12px", fontStyle: "italic" }}>
            {subtitle}
          </span>
        )}
      </div>
      {showCollapseControl && (
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
          {collapsed ? (
            <IconChevronDown size={20} />
          ) : (
            <IconChevronUp size={20} />
          )}
        </div>
      )}
    </>
  );

  if (asTableHeader) {
    return (
      <thead>
        <tr>
          <th
            colSpan={999}
            className="section-title"
            style={sharedStyles}
            onClick={showCollapseControl ? handleToggleCollapse : undefined}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 5,
              }}>
              {content}
            </div>
          </th>
        </tr>
      </thead>
    );
  }

  return (
    <div
      className="section-title"
      style={{
        ...sharedStyles,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 5,
      }}
      onClick={showCollapseControl ? handleToggleCollapse : undefined}>
      {content}
    </div>
  );
};
export default SectionTitle;
